/**
 * Mapeo de strings de iconos a componentes de react-icons
 * Usa Feather Icons (Fi) para un diseño minimalista
 */

import {
    FiSettings,
    FiBook,
    FiLayout,
    FiFileText,
    FiCircle,
    FiUsers,
    FiHome,
    FiBarChart2,
    FiList,
    FiFolder,
    FiUser,
    FiMail,
    FiCalendar,
    FiClock,
    FiCheckCircle,
    FiXCircle,
    FiAlertCircle,
    FiInfo,
    FiChevronDown,
    FiChevronRight,
    FiMenu,
    FiX,
    FiEye,
    FiEyeOff,
} from 'react-icons/fi';
import { IconType } from 'react-icons';

/**
 * Mapeo de strings de iconos a componentes de react-icons
 */
const iconMap: Record<string, IconType> = {
    // Iconos comunes del sistema
    settings: FiSettings,
    school: FiBook,
    dashboard: FiLayout,
    application: FiFileText,
    applications: FiFileText,
    users: FiUsers,
    book: FiBook,
    home: FiHome,
    chart: FiBarChart2,
    list: FiList,
    folder: FiFolder,
    user: FiUser,
    mail: FiMail,
    calendar: FiCalendar,
    clock: FiClock,
    check: FiCheckCircle,
    x: FiXCircle,
    alert: FiAlertCircle,
    info: FiInfo,
    eye: FiEye,
    eyeOff: FiEyeOff,
    // Iconos de navegación
    chevronDown: FiChevronDown,
    chevronRight: FiChevronRight,
    menu: FiMenu,
    close: FiX,
};

/**
 * Obtiene el componente de icono correspondiente al string proporcionado
 * @param iconName Nombre del icono (case-insensitive)
 * @returns Componente de icono o FiCircle como fallback
 */
export function getIcon(iconName: string | undefined): IconType {
    if (!iconName) {
        return FiCircle;
    }

    const normalizedName = iconName.toLowerCase().trim();
    return iconMap[normalizedName] || FiCircle;
}

